import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/query-params';

export interface DrawerTabConfig {
  label: string;
  key: string;
}

export interface DrawerTabHelpers {
  activeIndex: number;
  activeTab: string | undefined;
  onTabChange: (tabIndex: number) => void;
}

export const useTabsNavigation = (
  tabs: DrawerTabConfig[],
  defaultTab?: string
): DrawerTabHelpers => {
  const { params, setQueryParams, deleteQueryParam } = useQueryParams();
  const activeTab = params[queryKeys.activeDrawerTab] || defaultTab;

  const onTabChange = (tabIndex: number) => {
    const tab = tabs[tabIndex];

    if (tab) {
      setQueryParams({ [queryKeys.activeDrawerTab]: tab.key });
    } else {
      deleteQueryParam(queryKeys.activeDrawerTab);
    }
  };

  const foundIndex = tabs.findIndex(tab => tab.key === activeTab);
  const activeIndex = foundIndex !== -1 ? foundIndex : 0;

  return {
    activeIndex,
    onTabChange,
    activeTab,
  };
};
